import types from '../../constants';

const initialState = {
  loading: false,
  loadingCompanies: false,
  downloading: false,
  deleting: false,
  modal: false,
  isUpdate: false,
  showError: false,
  mapEditorShown: false,
  error: '',
  currentScenario: '',
  currentScenarioMapInfo: '',
  currentRepository: '',
  currentRepoSim: '',
  companies: [],
  repositories: [],
  repoScenarios: [],
  data: [],
  filter: {
    name: '',
    company: '',
  },
};

const ScenariosReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.SCENARIOS_FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case types.SCENARIOS_FETCH_END:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case types.SCENARIOS_FETCH_REPOS_START:
      return {
        ...state,
        loading: true,
      };
    case types.SCENARIOS_FETCH_REPOS_END:
      return {
        ...state,
        repositories: action.payload,
        loading: false,
      };
    case types.SCENARIOS_FETCH_REPO_START:
      return {
        ...state,
        loading: true,
      };
    case types.SCENARIOS_FETCH_REPO_END:
      return {
        ...state,
        repoScenarios: action.payload,
        loading: false,
      };
    case types.SCENARIOS_LOAD_START:
      return {
        ...state,
        loading: true,
      };
    case types.SCENARIOS_LOAD_END:
      return {
        ...state,
        loading: false,
      };
    case types.SCENARIOS_DOWNLOAD_START:
      return {
        ...state,
        downloading: true,
      };
    case types.SCENARIOS_DOWNLOAD_END:
      return {
        ...state,
        downloading: false,
      };
    case types.SCENARIOS_DELETE_START:
      return {
        ...state,
        deleting: true,
      };
    case types.SCENARIOS_DELETE_END:
      return {
        ...state,
        deleting: false,
      };
    case types.SCENARIOS_UPLOAD_START:
      return {
        ...state,
        uploading: true,
      };
    case types.SCENARIOS_UPLOAD_END:
      return {
        ...state,
        uploading: false,
      };
    case types.SCENARIOS_CHANGE_MODAL_STATE:
      return {
        ...state,
        modal: action.payload,
      };
    case types.SCENARIOS_SELECT:
      return {
        ...state,
        currentScenario: action.payload && action.payload._id? action.payload._id : '',
        currentScenarioMapInfo: action.payload && action.payload.mapInfo? action.payload.mapInfo: ''
      };
    case types.SCENARIOS_SELECT_REPO:
      return {
        ...state,
        currentRepository: action.payload,
      };
    case types.SCENARIOS_SELECT_REPO_SIM:
      return {
        ...state,
        currentRepoSim: action.payload,
      };
    case types.SCENARIOS_SET_UPDATE_FLAG:
      return {
        ...state,
        isUpdate: action.payload,
      };
    case types.SCENARIOS_SET_ERROR_MESSAGE:
      return {
        ...state,
        showError: true,
        error: action.payload,
      };
    case types.SCENARIOS_CLEAR_ERROR:
      return {
        ...state,
        showError: false,
        error: '',
      };
    case types.SCENARIOS_CLOSE_ERROR:
      return {
        ...state,
        showError: false,
      };
    case types.COMPANIES_FETCH_START:
      return {
        ...state,
        loadingCompanies: true,
      };
    case types.COMPANIES_FETCH_END:
      return {
        ...state,
        companies: action.payload,
        loadingCompanies: false,
      };
    case types.SCENARIOS_CHANGE_FILTER:
      const newFilter = {...state.filter};
      const {key, value} = action.payload;
      newFilter[key] = value;

      return {
        ...state,
        filter: newFilter,
      };
    case types.SCENARIO_RESET_FILTER:
      return {
        ...state,
        filter: {},
      };
    case types.SCENARIOS_MAPEDITOR_TOGGLE:
      let new_state = typeof action.payload !== undefined ? action.payload : !state.mapEditorShown;
      return {
        ...state,
        mapEditorShown: new_state
      }

    default:
      return state;
  }
};

export default ScenariosReducers;
